import SpaceForButton from '@/components/_common/SpaceForButtons';
import { YardReportFormValues } from '@/core/domain/visual-management/yard-report/yard-report.types';
import { useDisclosure } from '@/hooks';
import { Button, Divider, Form, FormInstance } from 'antd';
import YardManagementReportList from './List';
import { useReportActions } from '@/hooks/useReportActions';
import { useYardReport } from '@/core/domain/visual-management/yard-report/yard-report.hooks';
import { DateTimeFormat } from '@/utils/moment';

interface Props {
  form: FormInstance<YardReportFormValues>;
}

export default function YardManagementReportActions(props: Props) {
  const [showList, showListAction] = useDisclosure(false);

  const values = Form.useWatch([], props.form);

  const generate = useYardReport();

  const { handleView, handlePdf, handleCsv, fileLoading } = useReportActions({
    fileName: 'relatorio-gestao-de-patio',
    generate: async (format) => {
      const result = await generate.mutateAsync({
        statusIds: values?.statusIds,
        dateFilter: values?.dateFilter,
        situationIds: values?.situationIds,
        vehicleIds: values?.vehicleIds?.toString(),
        companyIds: values?.companiesIds?.toString(),
        customerIds: values?.customerIds?.toString(),
        estimatorIds: values?.estimatorIds?.toString(),
        technicianIds: values?.technicianIds?.toString(),
        endDate: values?.finalDate.format(DateTimeFormat),
        startDate: values?.initialDate.format(DateTimeFormat),
        responseType: format === 'CSV' ? 'Csv' : 'Pdf',
      });

      return result;
    },
  });

  return (
    <>
      {showList && (
        <>
          <SpaceForButton style={{ marginBottom: 24 }}>
            <Button type="primary" block onClick={showListAction.close}>
              Ocultar Listagem
            </Button>
          </SpaceForButton>

          <YardManagementReportList form={props.form} />

          <Divider />
        </>
      )}

      <SpaceForButton>
        {!showList && (
          <Button type="primary" block onClick={showListAction.open}>
            Exibir Listagem
          </Button>
        )}

        <Button
          type="primary"
          block
          onClick={handleView}
          loading={fileLoading.REPORT_VIEW}
        >
          Visualizar Relatório
        </Button>

        <Button
          type="primary"
          block
          onClick={handlePdf}
          loading={fileLoading.PDF}
        >
          Gerar PDF
        </Button>

        <Button
          type="primary"
          block
          onClick={handleCsv}
          loading={fileLoading.CSV}
        >
          Gerar CSV
        </Button>
      </SpaceForButton>
    </>
  );
}
